import {
  AddJobIcon,
  AddNoteIcon,
  ArchiveJobIcon,
  BinIcon,
  BlueTickInABrokenCircleIcon,
  ChangeStatusIcon,
  DuplicateIcon,
  InvoicesTabIcon,
  JobsTabIcon,
  SendLineIcon,
  TickInARollIcon
} from 'assets/icons';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

/* eslint-disable react/no-multi-comp */
export const ShareEstimateAction: FC<{ onShareEstimate: VoidFn }> = ({ onShareEstimate }) => (
  <div
    id="estimate-table-3dot-share-estimate"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onShareEstimate();
    }}>
    <SendLineIcon className="h-4 w-4 shrink-0" />
    <div>Share estimate</div>
  </div>
);

export const ArchiveEstimateAction: FC<{ onArchiveEstimate: VoidFn }> = ({ onArchiveEstimate }) => (
  <div
    id="estimate-table-3dot-archive-estimate"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onArchiveEstimate();
    }}>
    <ArchiveJobIcon className="shrink-0" />
    <div>Archive estimate</div>
  </div>
);

export const MarkAsAcceptedAction: FC<{ onMarkAsAccepted: VoidFn }> = ({ onMarkAsAccepted }) => (
  <div
    id="estimate-table-3dot-mark-as-accepted"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onMarkAsAccepted();
    }}>
    <BlueTickInABrokenCircleIcon className="shrink-0" />
    <div>Mark as accepted</div>
  </div>
);

export const DuplicateEstimateAction: FC<{ onDuplicateEstimate: VoidFn }> = ({ onDuplicateEstimate }) => (
  <div
    id="estimate-table-3dot-duplicate-estimate"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onDuplicateEstimate();
    }}>
    <DuplicateIcon className="shrink-0" />
    <div>Duplicate estimate</div>
  </div>
);

export const AddInvoiceAction: FC<{ onAddInvoice: VoidFn }> = ({ onAddInvoice }) => (
  <div
    id="estimate-table-3dot-add-invoice"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onAddInvoice();
    }}>
    <TickInARollIcon className="shrink-0" />
    <div>Add invoice</div>
  </div>
);

export const AddJobAction: FC<{ onAddJob: VoidFn }> = ({ onAddJob }) => (
  <div
    id="estimate-table-3dot-add-job"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onAddJob();
    }}>
    <AddJobIcon className="path-fill-current shrink-0 text-secondary" />
    <div>Add job</div>
  </div>
);

export const DeleteEstimateAction: FC<{ onDeleteEstimate: VoidFn }> = ({ onDeleteEstimate }) => (
  <div
    id="estimate-table-3dot-delete-estimate"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onDeleteEstimate();
    }}>
    <BinIcon className="path-fill-current h-4 w-4 shrink-0 text-secondary" />
    <div>Delete estimate</div>
  </div>
);

export const ViewInvoiceAction: FC<{ onViewInvoice: VoidFn }> = ({ onViewInvoice }) => (
  <div
    id="estimate-table-3dot-view-invoice"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onViewInvoice();
    }}>
    <InvoicesTabIcon className="path-stroke-current h-4 w-4 shrink-0 text-secondary" />
    <div>View invoice</div>
  </div>
);

export const ViewJobAction: FC<{ onViewJob: VoidFn }> = ({ onViewJob }) => (
  <div
    id="estimate-table-3dot-view-job"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onViewJob();
    }}>
    <JobsTabIcon className="path-fill-current h-4 w-4 shrink-0 text-secondary" />
    <div>View job</div>
  </div>
);

export const ChangeStatusAction: FC<{ onChangeStatus: VoidFn }> = ({ onChangeStatus }) => (
  <div
    id="estimate-table-3dot-change-status"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onChangeStatus();
    }}>
    <ChangeStatusIcon className="shrink-0" />
    <div>Change status</div>
  </div>
);

export const AddNoteAction: FC<{ onAddNote: VoidFn }> = ({ onAddNote }) => (
  <div
    id="estimate-table-3dot-add-note"
    className="flex flex-row items-center gap-2"
    onClick={e => {
      e.stopPropagation();
      onAddNote();
    }}>
    <AddNoteIcon className="path-fill-current h-4 w-4 shrink-0 text-secondary " />
    <div>Add note</div>
  </div>
);
